import { render, staticRenderFns } from "./MyOrdersDashboard.vue?vue&type=template&id=b252fad6"
import script from "./MyOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./MyOrdersDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports